import { useEffect, useMemo, useState } from 'react';

import { usePrevious, useToggle } from '@mantine/hooks';

function useDataOrdering() {
    const [orderDirection, toggleOrderDirection] = useToggle(['', 'asc', 'desc']);
    const [orderingField, setOrderingField] = useState('');
    const previousField = usePrevious(orderingField);

    function setOrdering(newOrdering) {
        if (newOrdering !== previousField) {
            setOrderingField(newOrdering);
            toggleOrderDirection('asc');

            return;
        }

        toggleOrderDirection();
    }

    useEffect(() => {
        if (orderDirection !== '') {
            return;
        }

        setOrderingField('');
    }, [orderDirection]);

    const ordering = useMemo(() => {
        if (!orderDirection || !orderingField) {
            return '';
        }

        const sign = orderDirection === 'desc' ? '-' : '';

        return `${sign}${orderingField}`;
    }, [orderDirection, orderingField]);

    return {
        ordering,
        setOrdering,
    };
}

export default useDataOrdering;
